module.exports = __webpack_public_path__ + "img/btn_select.ff793899.svg";